import { makeStyles } from "@material-ui/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";


export default makeStyles((theme) => ({
  sideBarList:{
    padding:'0px !important'
  },
  navIconButton: {
    color: 'white !important',
    marginLeft:'10px !important'
},
parentMenu:{
  background:'#9FBEAF',
  borderBottom:'1px solid #d9dada',
  color:'white'
},
activeMenu:{
  background:'linear-gradient(134.89deg, #494DF4 24.95%, #9FBEAF )',
  color:'white'
},
activeChildMenu:{
  background:'linear-gradient(134.89deg,  #9FBEAF 75.05%,#494DF4 24.95%)',
  color:'white'
},
activeIcon:{
  color:'white'
}
}));
